import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Row, Upload, message } from 'antd';
import { FormBox, InputBox } from '../../../components/AntdAddons';
import { validations } from '../../../config/validations/validations';
import { UploadOutlined } from '@ant-design/icons';
import SVGIcon from '../../../utils/SVGIcon';
import { Notification, dataToFormDataConverter } from '../../../config/Global';
import { CONSTANT } from '../../../config/Constant';
import { BtnBold, BtnItalic, Editor, EditorProvider, Toolbar } from 'react-simple-wysiwyg';
import { getProviderList } from '../../../store/SendEmailSupportSlice';
import { AppDispatch } from '../../../store/app';
import { useDispatch } from 'react-redux';

const defaultData = `<p>
שלום רב,<br />
אני מקווה שהודעה זו מוצאת אתכם בטוב. אני פונה אליכם בנוגע לתקלה שנתקלתי בה לאחרונה.
</p>

<p>
תיאור התקלה: [תאר במפורט את התקלה, מה קורה, באיזה שלב היא מתרחשת, האם יש הודעות שגיאה, וכו']
</p>

<p>
אני מקווה שתוכלו לסייע לי בפתרון התקלה בהקדם האפשרי. אשמח לקבל כל מידע או הנחיות נוספות שיוכלו לעזור לי להתמודד עם הבעיה.
</p>

<p>
תודה רבה על העזרה והזמן שלכם.
</p>

<p>
<b>מספר:</b> %number%<br />
</p>
<p>
צרפנו קובץ כולל פירוט מלא נשמח לעדכון בלינק המצורף<br/><b>%url%</b>
</p>

<p>
בברכה,<br />
פייקול
</p>
`

const SendSupportForm: React.FC<any> = ({ getList }) => {
    const dispatch: AppDispatch = useDispatch()
    const [form] = Form.useForm();
    const [fileList, setFileList] = useState<any>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [msgValue, setMsgValue] = useState(defaultData);
    const [providerList, setProviderList] = useState<any>([]);
    const [providerDropdown, setProviderDropdown] = useState<any>();
    const authToken = localStorage.getItem('token');

    var myHeaders = new Headers();
    myHeaders.append('Authorization', authToken ? authToken : '');

    const handleSubmit = async (data?: any) => {
        setLoading(true);
        data.text_body = msgValue;

        const formData = dataToFormDataConverter(data);

        if (fileList.length > 0) {
            formData.append('file', fileList[0]?.originFileObj);
        }
        try {
            const response = await fetch(`${CONSTANT.BASE_URL}/emailSupport/add`, {
                method: 'POST',
                body: formData,
                headers: myHeaders,
            });

            if (response.ok) {
                setLoading(false);
                // console.log('File uploaded successfully!');
                Notification.success({
                    message: 'File uploaded successfully.',
                });
            } else {
                setLoading(false);
                // console.log('File upload failed......');
                Notification.error({
                    message: 'Email send failed',
                });
            }
            form.resetFields();
            getList();
            fetchProviderList();
            setProviderList([]);
            setProviderDropdown([]);
        } catch (error) {
            setLoading(false);
            // console.log('File upload failed.');
            console.error('Error uploading file:', error);
            Notification.error({
                message: 'File upload failed.',
            });
        }
    };
    // for validation
    const handleChange = () => {
        form
            .validateFields()
            .then(() => {
                // setDisable(false);
            })
            .catch((error: any) => {
                // setDisable(true);
            });
    };

    const beforeUpload = (file: any) => {
        const isLt10MB = file.size / 1024 / 1024 <= 10;
        if (!isLt10MB) {
            message.error(`${file.name} is larger than 10MB`);
            return Upload.LIST_IGNORE;
        }
        const acceptedFileTypes = [
            'image/jpeg', 'image/png', 'application/pdf', 'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.oasis.opendocument.text', 'application/vnd.oasis.opendocument.spreadsheet',
            'application/vnd.oasis.opendocument.presentation', 'application/zip', 'image/jpg'
        ];

        if (!acceptedFileTypes.includes(file.type)) {
            message.error(`${file.name} is not a valid file type`);
            return Upload.LIST_IGNORE;
        }
        return isLt10MB;
    };

    const handleFileChange = ({ fileList }: any) => {
        setFileList(fileList);
        form.setFieldsValue({ file: fileList.length ? fileList : null });
    };

    function onChange(e) {
        setMsgValue(e.target.value);
    }

    const fetchProviderList = () => {
        dispatch(getProviderList()).then((data: any) => {
            setProviderList(data.data)
        }).catch((e: any) => {
            setProviderList([])
            console.warn("e", e);
        })
    }

    useEffect(() => {
        fetchProviderList()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <FormBox
                className="filterForm"
                form={form}
                onFinish={handleSubmit}
                onChange={handleChange}
                validateTrigger={['onBlur', 'onInput']}
                autoComplete="off"
                initialValues={{
                    text_body:
                        'Hello, Please find Number details: Number = %number% . Thank you.',
                }}
            >
                <Row
                    gutter={[20, 0]}
                    align={'top'}
                >
                    <Col
                        xs={24}
                        md={12}
                        lg={8}
                        xl={6}
                    >
                        <InputBox.Text
                            label=" Number"
                            name={'number'}
                            tooltip="A single number to request to be ported. Must be in a domestic form (e.g. 12223555 or *3555)"
                            required
                            rules={[
                                validations.required.text('Number'),
                                validations.pattern.numericWithSecial,
                                // validations.pattern.whitespace,
                            ]}
                        />
                    </Col>
                    <Col
                        xs={24}
                        md={12}
                        lg={8}
                        xl={6}
                    >
                        <InputBox.Select
                            label='Provider Type'
                            name={"providerType"}
                            placeholder='Provider Type'
                            rules={[
                                validations.required.select('Provider Type')
                            ]}
                            onChange={(e) => {
                                form.resetFields(['provider_id'])
                                if (e === CONSTANT.ALL_PROVIDERS.NETWORK_PROVIDER) {
                                    setProviderDropdown(providerList.networkProviders);
                                } else if (e === CONSTANT.ALL_PROVIDERS.NOC_PROVIDER) {
                                    setProviderDropdown(providerList.nocProviders);
                                } else if (e === CONSTANT.ALL_PROVIDERS.SUPPORT_PROVIDER) {
                                    setProviderDropdown(providerList.supportProviders);
                                } else {
                                    setProviderDropdown([]);
                                }
                            }}
                            options={{
                                list: CONSTANT.PROVIDERS,
                                textKey: "providers_code",
                                valueKey: "id"
                            }}
                        />
                    </Col>
                    <Col
                        xs={24}
                        md={12}
                        lg={8}
                        xl={6}
                    >
                        <InputBox.Select
                            label='Providers'
                            name={"provider_id"}
                            placeholder='Providers'
                            rules={[
                                validations.required.select('Providers')
                            ]}
                            options={{
                                list: providerDropdown,
                                textKey: "provider_code",
                                valueKey: "id"
                            }}
                        />
                    </Col>
                    <Col
                        xs={24}
                        md={12}
                        lg={8}
                        xl={6}
                    >
                        <InputBox.Text
                            label="Name"
                            name={'name'}
                            rules={[validations.required.text('Name'), validations.pattern.whitespace]}
                        />
                    </Col>
                    <Col
                        xs={24}
                        md={12}
                        lg={6}
                        xl={6}
                    >
                        <Form.Item
                            name="file"
                            label="Upload File"
                            rules={[{ required: true, message: 'Please upload a file.' }]}
                        >
                            <Upload
                                beforeUpload={beforeUpload}
                                maxCount={1}
                                // onRemove={onRemoveFile}
                                // fileList={fileList}
                                onChange={handleFileChange}
                                listType="text"
                                accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.odt,.ods,.odp,.zip"
                            >
                                <Button icon={<UploadOutlined />}>Upload File</Button>
                            </Upload>
                        </Form.Item>
                    </Col>
                    <Col xs={24}>
                        <EditorProvider>
                            <Editor
                                containerProps={{ style: { resize: 'vertical' } }}
                                value={msgValue}
                                onChange={onChange}
                            // dir="rtl"
                            >
                                <Toolbar>
                                    <BtnBold />
                                    <BtnItalic />
                                </Toolbar>
                            </Editor>
                            <p>
                                <span className="text-red">Note:</span> %number% means Number / %url% means URL for confirmation.
                            </p>
                        </EditorProvider>
                    </Col>
                    <Col
                        xs={12}
                        md={6}
                        lg={6}
                        xl={4}
                    >
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                        >
                            <SVGIcon
                                icon="add"
                                color="#fff"
                                width={55}
                            />
                            Add{' '}
                        </Button>
                    </Col>
                    <Col
                        xs={12}
                        md={6}
                        lg={6}
                        xl={4}
                    >
                        <Button
                            type="default"
                            htmlType="reset"
                            onClick={() => {
                                setFileList([]);
                                form.resetFields();
                            }}
                        >
                            Clear
                        </Button>
                    </Col>
                </Row>
            </FormBox>
        </>
    );
};

export default SendSupportForm;
